export default __webpack_public_path__ + "static/media/hero.8af272c2.jpg";